import React from 'react';
import Button from './Button';

const CTA = () => (
  <section className='flex justify-center items-center flex-col sm:flex-row bg-black-gradient-2 rounded-[20px] box-shadow sm:px-16 px-6 sm:py-12 py-4 sm:my-16 my-6'> 

    <div className='flex-1 flex flex-col'>
      <h2 className='flex-1 font-poppins font-semibold xs:text-[48px] text-[40px] xs:leading-[76.8px] leading-[66.8px] text-white'>Let's try our service now!</h2>
      <p className='font-poppins text-dimWhite text-[18px] leading-[30.8px] max-w-[470px] mt-5'>Everything you need to accept card payments and grow your business anywhere on the planet.</p>
    </div>

    <div className='flex justify-center items-center sm:ml-10 ml-0 sm:mt-0 mt-10'>
      <Button />
    </div>

  </section>
)

export default CTA
